import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import GrapeList from './GrapeList';
import GrapeForm from './GrapeForm';

const GrapeRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<GrapeList />} />
      <Route path="/create" element={<GrapeForm />} />
      <Route path="/edit/:grapeId" element={<GrapeForm />} />
      <Route path="*" element={<Navigate to="/admin/grapes" replace />} />
    </Routes>
  );
};

export default GrapeRoutes;
